import React from 'react';

// Provides a global loading state and setter across the app
const LoadingContext = React.createContext({
  loading: false,
  setLoading: () => {},
});

export default LoadingContext;
